export default {
  path: 'rpproviderbilingstatusindicator',
  component: () =>
    import('@/views/dashboard/RpProviderBillingStatusIndicator/Wrapper.vue'),
  children: [
    {
      path: '',
      name: 'rpproviderbilingstatusindicator',
      component: () =>
        import('@/views/dashboard/RpProviderBillingStatusIndicator/Main.vue'),
    },
  ],
}
